import { Editor } from '@tldraw/tldraw'
import { ColorsPanelContainerProps } from 'components/Design/ColorsPanel/Types'

export type PanelName = 'colors' | 'textStyles' | 'fontFamily'
export const DesktopPanels: PanelName[] = ['colors']
export const MobilePanels: PanelName[] = ['colors', 'textStyles', 'fontFamily']

type ColorsPanelType = { type: 'colors' } & ColorsPanelContainerProps
type TextStylesPanelType = { type: 'textStyles' }
type FontFamilyPanelType = { type: 'fontFamily' }

export type PanelType = ColorsPanelType | TextStylesPanelType | FontFamilyPanelType

export type TabType =
  | 'templates'
  | 'text'
  | 'elements'
  | 'uploads'
  | 'brand'
  | 'caption'
  | 'template_admin'
  | 'backgrounds'
  | 'layers'
  | 'publish'
  | 'resize'

export type Callback = (editor: Editor) => any
/**
 * Callbacks to be run when the editor is set.
 * When a tldraw store is created, the editor is not available yet, so these
 * callbacks act as hooks to run code when the editor is set.
 */
export type Callbacks = {
  /**
   * Run when loading a file with no content.
   */
  onFileCreate?: Callback
}

export type Config = {
  fileId: string
  brandVisualKitId?: number
}
